import React from 'react';
import { Grid, Row, Col } from '@vds/grids';
import { TextLink } from '@vds/buttons';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';

import { Title } from '../../../common/Typography/index';
import { isPreorder, isWHWP2, viewport } from '../../../common/Helpers/index';
import { getFirstName, getLastName } from '../../../common/ContactInfoUtils';

const ConfirmationHeading = (props) => {
  const type = viewport();
  const { contactInfoValues } = props;

  let heading;
  const firstName = getFirstName(contactInfoValues, contactInfoValues?.firstName, props.isAALContactInfoUpdated);
  const lastName = getLastName(contactInfoValues, contactInfoValues?.lastName, props.isAALContactInfoUpdated);

  if (isPreorder()) {
    heading = `${firstName} ${lastName}, ${parse(props.newPreOrderConfirmationText)}`;
  } else if (isWHWP2() && props?.isredemptionDowngrade) {
    heading = props.whwDowngradeHeader;
  } else {
    heading = `${firstName} ${lastName}, ${parse(props.newOrderConfirmationText)}`;
  }

  return (
    <Grid>
      <Row className="headerMob">
        <Col colSizes={{ mobile: 4, tablet: 9, desktop: 9 }} className="onlyTopMargin lineHeight25 letterSpacing_0 sample noSidePad vdsOverride">
          <Title primitive="h1" size="XLarge">
            {heading}
          </Title>
        </Col>
        <Col colSizes={{ mobile: 0, tablet: 3, desktop: 3 }}>
          {(type === 'desktop' || type === 'tablet') && !props?.isredemptionDowngrade && (
            <span className="skipPrint Icon Icon--print printIcon">
              <TextLink className="printReceipt" type="standAlone" onClick={() => window.print()} ariaLabel="Print Receipt">
                {props.printReceipt}
              </TextLink>
            </span>
          )}
        </Col>
      </Row>
    </Grid>
  );
};

ConfirmationHeading.propTypes = {
  printReceipt: PropTypes.string,
  contactInfoValues: PropTypes.object,
  isAALContactInfoUpdated: PropTypes.bool,
  newOrderConfirmationText: PropTypes.string,
  newPreOrderConfirmationText: PropTypes.string,
  isredemptionDowngrade: PropTypes.bool,
  whwDowngradeHeader: PropTypes.string,

};

export default React.memo(ConfirmationHeading);
